import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Form, Field } from 'react-final-form';

import FormError from 'components/form/FormError';

const messages = defineMessages({
  PLACEHOLDER_WRITE_NOTE: {
    id: 'ChatInput.PLACEHOLDER_WRITE_NOTE',
    defaultMessage: 'Schreiben Sie eine Notiz',
  },
  VALUE_CREATE_NOTE: {
    id: 'ChatInput.VALUE_CREATE_NOTE',
    defaultMessage: 'Notiz erstellen',
  },
  VALIDATION_FIELD_REQUIRED: {
    id: 'ChatInput.VALIDATION_FIELD_REQUIRED',
    defaultMessage: 'Dieses Feld ist erforderlich.',
  },
});

function ChatInputComponent(props) {
  const {
    intl: { formatMessage },
  } = props;

  const onSubmitLocal = (data, form) => {
    return props.onSubmit(data, form);
  }

  return (
    <div style={{ width: '100%' }}>
      <Form
        onSubmit={onSubmitLocal}
        validate={values => {
          const errors = {};
          if (!values.text) {
            errors.text = formatMessage(messages.VALIDATION_FIELD_REQUIRED);
          }
          return errors;
        }}
      >
        {({ submitError, handleSubmit}) => (
          <form onSubmit={handleSubmit} style={{ margin: 0, width: '100%' }}>
            <FormError error={submitError} />
            <div style={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center' }}>
              <Field name="text">
                {({ input, meta }) => {
                  return (
                    <input
                      {...input}
                      type="text"
                      placeholder={formatMessage(messages.PLACEHOLDER_WRITE_NOTE)}
                      autoComplete="off"
                      style={{
                        flex: '1 1 auto',
                        minWidth: 0,
                        height: '38px',
                        boxSizing: 'border-box',
                        padding: '0 16px',
                        borderRadius: '8px',
                        border: '1px solid var(--panel-border, #334155)',
                        background: 'var(--panel-bg, #1e293b)',
                        color: 'white',
                        fontSize: '14px',
                        outline: 'none'
                      }}
                    />
                  )
                }}
              </Field>
              <button
                type="submit"
                className="lh-btn lh-btn-primary"
                style={{
                  flexShrink: 0,
                  height: '38px',
                  boxSizing: 'border-box'
                }}
              >
                {formatMessage(messages.VALUE_CREATE_NOTE)}
              </button>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
}

export default injectIntl(ChatInputComponent);
